// @flow
import * as React from 'react';
import { rankWith, uiTypeIs, isEnumControl, or } from '@jsonforms/core';
import { Box, Stack } from '@locus-taxy/neo-ui';

import TeamInput from '../components/TeamInput';
import useControlProps from '../util/useControlProps';
import { useClientSettings } from 'platform/settings/hooks/useClientSettings';
import { useTeamSettingsByTeamId } from 'platform/settings/hooks/useTeam';
import MaraOnlyTag from '../components/MaraOnlyTag';

type Props = {};

export const VAETeamControl = (props: Props): React.Node => {
    const {
        label,
        path,
        data,
        handleChange,
        uischema: { options }
    } = useControlProps(props);
    const clientSettings = useClientSettings();
    const teamSettings = useTeamSettingsByTeamId();

    const { isMaraOnlyField } = options || {};

    const onChange = (path, value) => {
        handleChange('clientSettings.vaeConfigs', {
            team: value
        });
        if (value === 'all_teams') {
            if (clientSettings.data) {
                const parsedData = JSON.parse(clientSettings.data.payload);
                if (parsedData.vaeConfiguration) {
                    handleChange('clientSettings.vaeConfigs', {
                        ...parsedData.vaeConfiguration,
                        team: value
                    });
                }
            }
        } else {
            teamSettings.mutate(
                { teamId: value },
                {
                    onSuccess: data => {
                        const parsedData = JSON.parse(data.payload);
                        if (parsedData.vaeConfiguration) {
                            handleChange('clientSettings.vaeConfigs', {
                                ...parsedData.vaeConfiguration,
                                team: value
                            });
                        }
                    }
                }
            );
        }
    };

    return (
        <Stack>
            <Box>
                <TeamInput
                    label={label}
                    value={data}
                    onChange={value => onChange(path, value)}
                />
            </Box>
            {isMaraOnlyField && (
                <Box py="1">
                    <MaraOnlyTag />
                </Box>
            )}
        </Stack>
    );
};

export default VAETeamControl;

export const vaeTeamControlTester: any = rankWith(
    1,
    or(uiTypeIs('VAETeamControl'), isEnumControl)
);
